import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./componant/homePage/Home";
import Header from "./common/Header";
import PeopleHomePage from "./componant/people/PeopleHomePage";
import BlogHomePage from "./componant/blog/BlogHomePage";
import Overview from "./componant/detailPage/innerPage/Overview";
import BioDiversity from "./componant/detailPage/innerPage/Programmes/BioDiversity";
import RestoringHope from "./componant/detailPage/innerPage/Programmes/RestoringHope";
import EmpoweringCommunities from "./componant/detailPage/innerPage/Programmes/EmpoweringCommunities";
import DonateHomePage from "./componant/detailPage/donate/DonateHomePage";
import CommunityAndResource from "./componant/detailPage/innerPage/Programmes/CommunityAndResource";
import CommunityAndWelbeing from "./componant/detailPage/innerPage/Programmes/CommunityAndWelbeing";
import SustainableFisheries from "./componant/detailPage/innerPage/Programmes/SustainableFisheries";
import Loogan from "./componant/detailPage/innerPage/features/Lagoon";
import Lagoon from "./componant/detailPage/innerPage/features/Lagoon";
import Neera from "./componant/detailPage/innerPage/features/Neera";
import FoodWeb from "./componant/detailPage/innerPage/features/FoodWeb";
import ProfilePage from "./componant/detailPage/innerPage/ProfilePage";
import Editorial from "./componant/detailPage/innerPage/publication/Editorial";
import Book from "./componant/detailPage/innerPage/publication/Book";
import Documentary from "./componant/detailPage/innerPage/publication/Documentary";
import EducationOutreach from "./componant/detailPage/innerPage/publication/EducationOutreach";
import FieldGuide from "./componant/detailPage/innerPage/publication/FieldGuide";
import FutureCalendar from "./componant/detailPage/innerPage/publication/FutureCalendar";
import JournalArticle from "./componant/detailPage/innerPage/publication/JournalArticle";
import ModulesandGuide from "./componant/detailPage/innerPage/publication/ModulesandGuide";
import OpinionandCommentaries from "./componant/detailPage/innerPage/publication/OpinionandCommentaries";
import PopularArticle from "./componant/detailPage/innerPage/publication/PopularArticle";
import Report from "./componant/detailPage/innerPage/publication/Report";
import Advisior from "./componant/detailPage/innerPage/advisior/Advisior";
import ProfilePageAdvisior from "./componant/detailPage/innerPage/advisior/ProfilePageAdvisior";
import Project from "./componant/detailPage/innerPage/project/Project";
import Administrative from "./componant/detailPage/innerPage/administrative/Administrative";
import BoardMembers from "./componant/detailPage/innerPage/BoardMembers/BoardMembers";
import FutureVoices from "./componant/detailPage/innerPage/features/FutureVoices";
import PublicSpeech from "./componant/detailPage/innerPage/features/PublicSpeech";
import YoungVoices from "./componant/detailPage/innerPage/features/YoungVoices";
import CartoonCompeition from "./componant/detailPage/innerPage/features/CartoonCompeition";
import HumourMeets from "./componant/detailPage/innerPage/features/HumourMeets";
import PaintingCompeition from "./componant/detailPage/innerPage/features/PaintingCompeition";
import ClimateCrisis from "./componant/detailPage/innerPage/features/ClimateCrisis";
import ReefLeads from "./componant/detailPage/innerPage/features/ReefLeads";
import OceanStruggles from "./componant/detailPage/innerPage/features/OceanStruggles";
import GalleryHomePage from "./componant/gallery/GalleryHomePage";
import GalleryDetailPage from "./componant/gallery/GalleryDetailPage";
import RisingSea from "./componant/detailPage/innerPage/features/RisingSea";
import Login from "./authentication/login/Login";
import ProtectedRoute from "./page-restriction/ProtectedRoute";
import Dashboard from "./dashboard/pages/DashBoard";
import EmployeesManager from "./dashboard/pages/employeeManager/EmployeesManager";
import AddUser from "./dashboard/pages/employeeManager/AddUser";
import FreshLeads from "./dashboard/pages/leadManager/FreshLeads";
import FakeLeads from "./dashboard/pages/leadManager/FakeLeads";
import FollowUpLeads from "./dashboard/pages/leadManager/FollowUpLeads";
import ConvertedLeads from "./dashboard/pages/leadManager/ConvertedLeads";
import GeneratedLeads from "./dashboard/pages/leadManager/GeneratedLeads";
import AddBlog from "./dashboard/pages/blog/AddBlog";
import BlogList from "./dashboard/pages/blog/BlogList";
import ViewBlog from "./dashboard/pages/blog/ViewBlog";
import EditBlog from "./dashboard/pages/blog/EditBlog";
import BlogApproveList from "./dashboard/pages/blogApproval/BlogApproveList";
import ApprovedBlog from "./dashboard/pages/blogApproval/ApprovedBlog";
import ViewBlogApprovedList from "./dashboard/pages/blogApproval/ViewBlogApprovedList";
import AddNewPage from "./dashboard/pages/universityManager/AddNewPage";
import ViewPage from "./dashboard/pages/universityManager/ViewPage";
import EditPage from "./dashboard/pages/universityManager/EditPage";
import PageList from "./dashboard/pages/universityManager/PageList";
import AddSite from "./dashboard/pages/seoManager/AddSite";
import StaticPages from "./dashboard/pages/seoManager/StaticPages";
import AddMetaData from "./dashboard/pages/seoManager/AddMeataData";
import Locations from "./dashboard/pages/universityManager/Locations";
import { CookiesProvider } from "react-cookie";
import store from "../src/global/redux/store";
import { Provider } from "react-redux";
import AddProgramme from "./dashboard/pages/programme/AddProgramme";
import ProgrammeList from "./dashboard/pages/programme/ProgrammeList";
import AddPublication from "./dashboard/pages/publication/AddPublication";
import PublicationList from "./dashboard/pages/publication/PublicationList";
import AddFeature from "./dashboard/pages/feature/AddFeature";
import FeatureList from "./dashboard/pages/feature/FeatureList";
import AddPeople from "./dashboard/pages/people/AddPeople";
import PeopleList from "./dashboard/pages/people/PeopleList";

function App() {
  return (
    <>
      <CookiesProvider>
        <Provider store={store}>
          <Router>
            {/* <Header /> */}
            <Routes>
              <Route path="/" element={<Home />} />

              <Route
                path="/biodiversity-of-lakshadweep"
                element={<BioDiversity />}
              />
              <Route path="/restoring-hope" element={<RestoringHope />} />
              <Route
                path="/empowering-communities"
                element={<EmpoweringCommunities />}
              />
              <Route
                path="/community-resource"
                element={<CommunityAndResource />}
              />
              <Route
                path="/community-welbeing"
                element={<CommunityAndWelbeing />}
              />
              <Route
                path="/sustainable-fisheries"
                element={<SustainableFisheries />}
              />

              <Route path="/lagoon-cleaning" element={<Lagoon />} />
              <Route path="/neera-tapping" element={<Neera />} />
              <Route path="/future-voices" element={<FutureVoices />} />
              <Route path="/public-speech" element={<PublicSpeech />} />
              <Route
                path="/cartoon-compeition"
                element={<CartoonCompeition />}
              />
              <Route path="/humour-meets" element={<HumourMeets />} />
              <Route
                path="/painting-compeition"
                element={<PaintingCompeition />}
              />
              <Route path="/climate-crisis" element={<ClimateCrisis />} />
              <Route path="/ocean-struggles" element={<OceanStruggles />} />
              <Route path="/reef-leads" element={<ReefLeads />} />
              <Route path="/young-voices" element={<YoungVoices />} />
              <Route path="/food-web" element={<FoodWeb />} />
              <Route path="/rising-sea" element={<RisingSea />} />
              <Route path="/profile/:id" element={<ProfilePage />} />
              <Route path="/profile/:id" element={<ProfilePageAdvisior />} />

              <Route path="/people-page" element={<PeopleHomePage />} />
              <Route path="/blog-page" element={<BlogHomePage />} />
              <Route path="/gallery" element={<GalleryHomePage />} />
              <Route path="/gallery/:id" element={<GalleryDetailPage />} />
              <Route path="/founder" element={<Overview />} />
              <Route path="/advisiors" element={<Advisior />} />
              <Route path="/project-members" element={<Project />} />
              <Route
                path="/advisory-board-members"
                element={<BoardMembers />}
              />
              <Route path="/administrative" element={<Administrative />} />
              <Route path="/donate" element={<DonateHomePage />} />

              <Route path="/book" element={<Book />} />
              <Route path="/documentary" element={<Documentary />} />
              <Route
                path="/education-outreach"
                element={<EducationOutreach />}
              />
              <Route path="/field-guide" element={<FieldGuide />} />
              <Route path="/future-calendar" element={<FutureCalendar />} />
              <Route path="/journal-article" element={<JournalArticle />} />
              <Route path="/modules-and-guide" element={<ModulesandGuide />} />
              <Route
                path="/opinionand-commentaries"
                element={<OpinionandCommentaries />}
              />
              <Route path="/popular-article" element={<PopularArticle />} />
              <Route path="/report" element={<Report />} />

              <Route path="/editorial" element={<Editorial />} />

              {/* admin dashboard */}
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/employee-manager/users"
                exact
                element={
                  <ProtectedRoute>
                    <EmployeesManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/employee-manager/add-user"
                exact
                element={
                  <ProtectedRoute>
                    <AddUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-manager/fresh-leads"
                exact
                element={
                  <ProtectedRoute>
                    <FreshLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-manager/fake-leads"
                exact
                element={
                  <ProtectedRoute>
                    <FakeLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-manager/follow-leads"
                exact
                element={
                  <ProtectedRoute>
                    <FollowUpLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-manager/converted-leads"
                exact
                element={
                  <ProtectedRoute>
                    <ConvertedLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-manager/generated-leads"
                exact
                element={
                  <ProtectedRoute>
                    <GeneratedLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-manager/add-blog"
                exact
                element={
                  <ProtectedRoute>
                    <AddBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-manager/blog-list"
                exact
                element={
                  <ProtectedRoute>
                    <BlogList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-manager/view-blog/:id"
                exact
                element={
                  <ProtectedRoute>
                    <ViewBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-manager/edit-blog/:id"
                exact
                element={
                  <ProtectedRoute>
                    <EditBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-approval/blog-approve-list"
                exact
                element={
                  <ProtectedRoute>
                    <BlogApproveList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-approval/approved-blog-list"
                exact
                element={
                  <ProtectedRoute>
                    <ApprovedBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-approval/approved-blog-list"
                exact
                element={
                  <ProtectedRoute>
                    <ApprovedBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog-approval/view-blog-approve-list/:id"
                exact
                element={
                  <ProtectedRoute>
                    <ViewBlogApprovedList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/web-settings/locations"
                exact
                element={
                  <ProtectedRoute>
                    <Locations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/web-settings/add-new-page"
                exact
                element={
                  <ProtectedRoute>
                    <AddNewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings-manager/view-page/:id"
                exact
                element={
                  <ProtectedRoute>
                    <ViewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings-manager/edit-page/:id"
                exact
                element={
                  <ProtectedRoute>
                    <EditPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/web-settings/page-list"
                exact
                element={
                  <ProtectedRoute>
                    <PageList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/seo-manager/add-sites"
                exact
                element={
                  <ProtectedRoute>
                    <AddSite />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/seo-manager/static-pages"
                exact
                element={
                  <ProtectedRoute>
                    <StaticPages />
                  </ProtectedRoute>
                }
              />
              {/* <Route
              path="/seo-manager/blog"
              exact
              element={
                <ProtectedRoute>
                  <DashBoardBlog />
                </ProtectedRoute>
              }
            /> */}
              <Route
                path="/seo-manager/add-metadata/:site/:id"
                element={
                  <ProtectedRoute>
                    <AddMetaData />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path="/seo-manager/edit-metadata/:site/:id"
                element={
                  <ProtectedRoute>
                    <EditMetaData />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/programme-manager/add-programme"
                exact
                element={
                  <ProtectedRoute>
                    <AddProgramme />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/programme-manager/programme-list"
                exact
                element={
                  <ProtectedRoute>
                    <ProgrammeList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/publication-manager/add-publication"
                exact
                element={
                  <ProtectedRoute>
                    <AddPublication />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/publication-manager/publication-list"
                exact
                element={
                  <ProtectedRoute>
                    <PublicationList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/feature-manager/add-feature"
                exact
                element={
                  <ProtectedRoute>
                    <AddFeature />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/feature-manager/feature-list"
                exact
                element={
                  <ProtectedRoute>
                    <FeatureList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/people-manager/add-people"
                exact
                element={
                  <ProtectedRoute>
                    <AddPeople />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/people-manager/people-list"
                exact
                element={
                  <ProtectedRoute>
                    <PeopleList />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </Provider>
      </CookiesProvider>
    </>
  );
}

export default App;
